/** Role and mention rules: staff can mention students; students can mention only staff */
export const ROLE_STAFF = 'staff';
export const ROLE_STUDENT = 'student';

function uniqueById(list) {
  const seen = new Set();
  return list.filter((u) => {
    const id = u?.id != null ? String(u.id) : null;
    if (id == null || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}

export function getMentionableUsers(currentUser, users) {
  if (!currentUser || !Array.isArray(users)) return [];
  const filtered = currentUser.role === ROLE_STAFF
    ? users.filter((u) => u.role === ROLE_STUDENT)
    : users.filter((u) => u.role === ROLE_STAFF);
  return uniqueById(filtered);
}
